import { render } from "./PageContainer.vue?vue&type=template&id=e5a40f52"
import script from "./PageContainer.vue?vue&type=script&lang=js"
export * from "./PageContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__